import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1a9f52bd = () => interopDefault(import('../pages/betalingsaccept.vue' /* webpackChunkName: "pages/betalingsaccept" */))
const _4430f016 = () => interopDefault(import('../pages/express-bank-afvist.vue' /* webpackChunkName: "pages/express-bank-afvist" */))
const _28e59164 = () => interopDefault(import('../pages/installment/index.vue' /* webpackChunkName: "pages/installment/index" */))
const _48e959e8 = () => interopDefault(import('../pages/internet/index.vue' /* webpackChunkName: "pages/internet/index" */))
const _e895b702 = () => interopDefault(import('../pages/kvittering.vue' /* webpackChunkName: "pages/kvittering" */))
const _07bd9644 = () => interopDefault(import('../pages/mitid/index.vue' /* webpackChunkName: "pages/mitid/index" */))
const _668c2ae3 = () => interopDefault(import('../pages/mobilabonnement/index.vue' /* webpackChunkName: "pages/mobilabonnement/index" */))
const _6105e98a = () => interopDefault(import('../pages/resurs-bank-afvist.vue' /* webpackChunkName: "pages/resurs-bank-afvist" */))
const _63352142 = () => interopDefault(import('../pages/shopkoeb/index.vue' /* webpackChunkName: "pages/shopkoeb/index" */))
const _1a3cf194 = () => interopDefault(import('../pages/styleguide/index.vue' /* webpackChunkName: "pages/styleguide/index" */))
const _073fb889 = () => interopDefault(import('../pages/sublist/index.vue' /* webpackChunkName: "pages/sublist/index" */))
const _e07cfe8e = () => interopDefault(import('../pages/info/udlandspriser.vue' /* webpackChunkName: "pages/info/udlandspriser" */))
const _609ee0e8 = () => interopDefault(import('../pages/installment/mock.vue' /* webpackChunkName: "pages/installment/mock" */))
const _e55d2688 = () => interopDefault(import('../pages/styleguide/colors.vue' /* webpackChunkName: "pages/styleguide/colors" */))
const _6c288941 = () => interopDefault(import('../pages/styleguide/elevation.vue' /* webpackChunkName: "pages/styleguide/elevation" */))
const _5da36504 = () => interopDefault(import('../pages/styleguide/icons.vue' /* webpackChunkName: "pages/styleguide/icons" */))
const _34bfb2fb = () => interopDefault(import('../pages/styleguide/typography.vue' /* webpackChunkName: "pages/styleguide/typography" */))
const _c33bafa2 = () => interopDefault(import('../pages/styleguide/components/button.vue' /* webpackChunkName: "pages/styleguide/components/button" */))
const _2261dac4 = () => interopDefault(import('../pages/styleguide/components/countdown.vue' /* webpackChunkName: "pages/styleguide/components/countdown" */))
const _173f8a01 = () => interopDefault(import('../pages/styleguide/components/form.vue' /* webpackChunkName: "pages/styleguide/components/form" */))
const _51f265c8 = () => interopDefault(import('../pages/styleguide/components/menu.vue' /* webpackChunkName: "pages/styleguide/components/menu" */))
const _53beb27b = () => interopDefault(import('../pages/styleguide/components/playmix.vue' /* webpackChunkName: "pages/styleguide/components/playmix" */))
const _112cb6aa = () => interopDefault(import('../pages/styleguide/components/sim.vue' /* webpackChunkName: "pages/styleguide/components/sim" */))
const _92324ce4 = () => interopDefault(import('../pages/styleguide/components/video.vue' /* webpackChunkName: "pages/styleguide/components/video" */))
const _19d8327a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3a886659 = () => interopDefault(import('../pages/familieabonnement/_subscriptionid/index.vue' /* webpackChunkName: "pages/familieabonnement/_subscriptionid/index" */))
const _5b1b38d7 = () => interopDefault(import('../pages/feed/_feed/index.vue' /* webpackChunkName: "pages/feed/_feed/index" */))
const _da9537d8 = () => interopDefault(import('../pages/internet/_subscriptionid/index.vue' /* webpackChunkName: "pages/internet/_subscriptionid/index" */))
const _edf41304 = () => interopDefault(import('../pages/kampagne/_campaign.vue' /* webpackChunkName: "pages/kampagne/_campaign" */))
const _f45ca42a = () => interopDefault(import('../pages/mobilabonnement/_subscriptionid/index.vue' /* webpackChunkName: "pages/mobilabonnement/_subscriptionid/index" */))
const _3dbb0cee = () => interopDefault(import('../pages/sitemap/_category/index.vue' /* webpackChunkName: "pages/sitemap/_category/index" */))
const _443073b3 = () => interopDefault(import('../pages/_categoryslug/index.vue' /* webpackChunkName: "pages/_categoryslug/index" */))
const _7522663a = () => interopDefault(import('../pages/_categoryslug/_brand/index.vue' /* webpackChunkName: "pages/_categoryslug/_brand/index" */))
const _f9cb3434 = () => interopDefault(import('../pages/_categoryslug/_brand/_productslug/index.vue' /* webpackChunkName: "pages/_categoryslug/_brand/_productslug/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/shop/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/betalingsaccept",
    component: _1a9f52bd,
    name: "betalingsaccept___da"
  }, {
    path: "/express-bank-afvist",
    component: _4430f016,
    name: "express-bank-afvist___da"
  }, {
    path: "/installment",
    component: _28e59164,
    name: "installment___da"
  }, {
    path: "/internet",
    component: _48e959e8,
    name: "internet___da"
  }, {
    path: "/kvittering",
    component: _e895b702,
    name: "kvittering___da"
  }, {
    path: "/mitid",
    component: _07bd9644,
    name: "mitid___da"
  }, {
    path: "/mobilabonnement",
    component: _668c2ae3,
    name: "mobilabonnement___da"
  }, {
    path: "/resurs-bank-afvist",
    component: _6105e98a,
    name: "resurs-bank-afvist___da"
  }, {
    path: "/shopkoeb",
    component: _63352142,
    name: "shopkoeb___da"
  }, {
    path: "/styleguide",
    component: _1a3cf194,
    name: "styleguide___da"
  }, {
    path: "/sublist",
    component: _073fb889,
    name: "sublist___da"
  }, {
    path: "/info/udlandspriser",
    component: _e07cfe8e,
    name: "info-udlandspriser___da"
  }, {
    path: "/installment/mock",
    component: _609ee0e8,
    name: "installment-mock___da"
  }, {
    path: "/styleguide/colors",
    component: _e55d2688,
    name: "styleguide-colors___da"
  }, {
    path: "/styleguide/elevation",
    component: _6c288941,
    name: "styleguide-elevation___da"
  }, {
    path: "/styleguide/icons",
    component: _5da36504,
    name: "styleguide-icons___da"
  }, {
    path: "/styleguide/typography",
    component: _34bfb2fb,
    name: "styleguide-typography___da"
  }, {
    path: "/styleguide/components/button",
    component: _c33bafa2,
    name: "styleguide-components-button___da"
  }, {
    path: "/styleguide/components/countdown",
    component: _2261dac4,
    name: "styleguide-components-countdown___da"
  }, {
    path: "/styleguide/components/form",
    component: _173f8a01,
    name: "styleguide-components-form___da"
  }, {
    path: "/styleguide/components/menu",
    component: _51f265c8,
    name: "styleguide-components-menu___da"
  }, {
    path: "/styleguide/components/playmix",
    component: _53beb27b,
    name: "styleguide-components-playmix___da"
  }, {
    path: "/styleguide/components/sim",
    component: _112cb6aa,
    name: "styleguide-components-sim___da"
  }, {
    path: "/styleguide/components/video",
    component: _92324ce4,
    name: "styleguide-components-video___da"
  }, {
    path: "/",
    component: _19d8327a,
    name: "index___da"
  }, {
    path: "/familieabonnement/:subscriptionid",
    component: _3a886659,
    name: "familieabonnement-subscriptionid___da"
  }, {
    path: "/feed/:feed",
    component: _5b1b38d7,
    name: "feed-feed___da"
  }, {
    path: "/internet/:subscriptionid",
    component: _da9537d8,
    name: "internet-subscriptionid___da"
  }, {
    path: "/kampagne/:campaign?",
    component: _edf41304,
    name: "kampagne-campaign___da"
  }, {
    path: "/mobilabonnement/:subscriptionid",
    component: _f45ca42a,
    name: "mobilabonnement-subscriptionid___da"
  }, {
    path: "/sitemap/:category",
    component: _3dbb0cee,
    name: "sitemap-category___da"
  }, {
    path: "/:categoryslug",
    component: _443073b3,
    name: "categoryslug___da"
  }, {
    path: "/:categoryslug/:brand",
    component: _7522663a,
    name: "categoryslug-brand___da"
  }, {
    path: "/:categoryslug/:brand/:productslug",
    component: _f9cb3434,
    name: "categoryslug-brand-productslug___da"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
